export interface IOrder {
  entity_id: string;
  created_at: string;
  timezone: string;
  external_order_id: string;
  status: string;
  is_owner: boolean;
  shipping_method: string;
  shipping_method_label: string;
  shipping_address: IShippingAddress;
  products: IProduct[];
  contact_rep_method: IContactRepMethod | '';
}

export interface IShippingAddress {
  name: string;
  street: string;
  city: string;
  state: string;
  postcode: string;
  country: string;
}

export interface IProduct {
  id: string;
  product_name: string;
  sku: string;
  type: string;
  attribute_set_name: string;
  qty: string;
  manufacturer_sku: string;
  manufacturer_id: string;
  assigned_rep: IAssignedRep | null;
  assignable_reps: IAssignableRep[];
  photo: string;
  color: string;
  brand: string;
  url: string;
  project: IProject;
  inventory_qty: string;
  product_qty_before_order: string;
  brand_status: number;
}

export interface IContactRepMethod {
  brand_id: string;
  project_id: string;
  selected_option: ContactRepMethod;
}

export interface IProject {
  id: string;
  name: string;
  phase: string;
  type: string;
}

export interface IAssignableRep {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
}

export interface IAssignedRep extends IAssignableRep {
  territory_details: string;
}

export interface ISortedOrders {
  products: SortedProducts;
  projects: IProject[];
}

export interface SortedProducts {
  [project_name: string]: {
    [brand_name: string]: {
      [order_date: string]: ISortedProject;
    };
  };
}

export interface ISortedProject {
  products: IProduct[];
  project: IProject;
  itemID: string;
  order_id: string;
}

export interface ProjectPhase {
  value: number;
  label: string;
}

export interface ProjectType {
  label: string;
  value: number;
}

export interface RepList {
  [manufacturerId: string]: Representatives;
}

export interface Representatives {
  assignableReps: IAssignableRep[];
  assignedRep: IAssignedRep | null;
}

export const enum ContactRepMethod {
  DISMISS_BRAND = 'dismiss_brand',
  READY_TO_SPECIFY = 'ready_to_specify',
  REQUEST_PRICING = 'request_pricing',
  REQUEST_AVAILABILITY = 'request_availability',
  REQUEST_LEAD_TIME = 'request_lead_time',
  CONTACT_ME = 'contact_me',
}

export enum TreatmentVariant {
  VARIANT_A = 'variant_a',
  VARIANT_B = 'variant_b',
  DEFAULT = 'default',
  CONTROL = 'control',
}

export interface TreatmentAttributes {
  groupID: string;
  hasOrderedWithinThirtyDays: boolean;
  isTestUser: boolean;
}

export interface representativesList {
  status: string;
  allowed: boolean;
  assigned_rep: IAssignedRep | null;
  assignable_reps_count: number;
  assignable_reps: IAssignableRep[];
}

export interface Option {
  label: string;
  value: number;
}
